/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreatePenaltyDetailsCommand } from '../../models/create-penalty-details-command';
import { CreatePenaltyDetailsCommandResult } from '../../models/create-penalty-details-command-result';

export interface ApiPenaltyDetailsCreatePenaltyDetailsPost$Params {
      body?: CreatePenaltyDetailsCommand
}

export function apiPenaltyDetailsCreatePenaltyDetailsPost(http: HttpClient, rootUrl: string, params?: ApiPenaltyDetailsCreatePenaltyDetailsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreatePenaltyDetailsCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiPenaltyDetailsCreatePenaltyDetailsPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreatePenaltyDetailsCommandResult>;
    })
  );
}

apiPenaltyDetailsCreatePenaltyDetailsPost.PATH = '/api/PenaltyDetails/CreatePenaltyDetails';
